import React, { Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ListPurchasesPage from './list-purchases-page';
import AddPurchasePage from './add-purchase-page';
import EditPurchasePage from './edit-purchase-page';

const PurchasesRoutingPages = ({ match }) => (
  <Suspense fallback={<div className="loading" />}>
    <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />

        <Route path={`${match.url}/list`}
          render={props => <ListPurchasesPage {...props} />}
        />

        <Route path={`${match.url}/add-new`}
          render={props => <AddPurchasePage {...props} />}
        />

        <Route path={`${match.url}/edit/:purchaseId`}
          render={props => <EditPurchasePage {...props} />}
        />

        <Redirect from={`${match.url}/`} to={`${match.url}/list`} />
        <Redirect to="/error" />
      </Switch>
    
  </Suspense>
);
export default PurchasesRoutingPages;
